<template>
  <div class="mains">
    <div class="campus">
      学生测试
      <span>></span>
      测试管理
      <span>></span>
      制作试题
    </div>
    <div class="student_test">

      <el-card>
        <div class="grid-content">
          <div class="rule">
            <div class="xiaoqu_1">制作习题</div>

          </div>
          <p class="tishi">
            <i>
              <img src="@/assets/img/education-manage/campus/shenzhong.png" alt />
            </i> 此页面为制作习题页面，您需要填入
          </p>
          <div class="form_1">
            <el-form ref="forms" :model="form" label-width="5.20833vw">
              <el-form-item label="习题标题">
                <el-input v-model="form.title" placeholder="请输入习题标题" class="shurukuang"></el-input>
              </el-form-item>
              <el-form-item label="阅读原文">
                <el-input type="textarea" v-model="form.content" class="xtfl" rows="5" @blur="submit()"></el-input>
              </el-form-item>
              <el-form-item label="习题类型" prop="name" class="xuanxiang">
                <el-select v-model="region" placeholder="请选择题型">
                  <el-option label="单选题" value="单选题"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="习题范例" prop="desc">
                <div class="xtfl1">
                  <h3>what is that ?</h3>
                  <div class="example">
                    <span>A: apple</span>
                    <span>B: banana</span>
                    <span>C: pear</span>
                    <span>D: orange</span>
                  </div>
                  <div class="example_img">
                    <img src="../../../../assets/img/xitifanli.png" alt="">
                  </div>
                </div>

              </el-form-item>
              <el-form-item label="习题个数" class="xuanxiang">
                <el-select v-model="textContent" placeholder="习题个数">
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                </el-select>
                &nbsp;
                <el-button>上一题</el-button>
                <el-button>下一题</el-button>

              </el-form-item>

              <el-form-item label="习题题目" prop="name">
                <el-input type="textarea" v-model="form.title1" class="xtfl" rows="5"></el-input>
              </el-form-item>
              <el-form-item label="选项个数" class="xuanxiang">
                <el-select v-model="value" placeholder="选项个数">
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                  <el-option label="3" value="3"></el-option>
                  <el-option label="4" value="4"></el-option>

                </el-select>
              </el-form-item>
              <el-form-item label="习题选项">
                <el-radio-group v-model="chooseListAnswer" @change="selector()">
                  <div class="options">
                    <div class="options_left">
                      <p>A</p>
                      <el-radio v-model="radio1" :label="questionOptions[0]" class="options_left_radio">设为正确答案</el-radio>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" v-model="form.desc1" rows="9" cols="85"></el-input>
                    </div>
                  </div>
                  <div class="options">
                    <div class="options_left">
                      <p>B</p>
                      <el-radio v-model="radio1" :label="questionOptions[1]" class="options_left_radio">设为正确答案</el-radio>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" v-model="form.desc2" rows="9" cols="85"></el-input>
                    </div>
                  </div>
                  <div class="options">
                    <div class="options_left">
                      <p>C</p>
                      <el-radio v-model="radio1" :label="questionOptions[2]" class="options_left_radio">设为正确答案</el-radio>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" v-model="form.desc3" rows="9" cols="85"></el-input>
                    </div>
                  </div>
                  <div class="options">
                    <div class="options_left">
                      <p>D</p>
                      <el-radio v-model="radio1" :label="questionOptions[3]" class="options_left_radio">设为正确答案</el-radio>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" v-model="form.desc4" rows="9" cols="85"></el-input>
                    </div>

                  </div>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="添加标签" prop="name">
                <el-select v-model="labelName" placeholder="选择标签">
                  <el-option v-for="item in xcxList" :value="item.id" :label="item.levelName" :key="item.id" @click.native="miniid=item.id">{{item.levelName}}</el-option>
                </el-select>
              </el-form-item>
              <div class="score">
                <el-form-item label="习题分数">
                  <el-input type="text" v-model="form.scoreNumber" class="grade" rows="5" placeholder="5分"></el-input>
                </el-form-item>
                <el-form-item label="习题数量">
                  <el-input type="text" v-model="form.questionCount" class="grade" rows="5" placeholder="20题"></el-input>
                </el-form-item>
                <el-form-item label="共计分数">
                  <el-input type="text" v-model="form.scoreCount" class="grade" rows="5" placeholder="100分"></el-input>
                </el-form-item>
              </div>
              <el-form-item class="tijiao">
                <el-button type="primary" @click="submitText()">提交</el-button>
                <router-link to="/testmangement">
                  <el-button>取消</el-button>
                </router-link>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-card>
    </div>

  </div>

</template>
<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
export default {
  components: { quillEditor },

  data() {
    return {
      form: {
        title: '',
        title1: '',
        content: '',
        questionCount: '',
        desc: '',
        leveName: '',
        questionCount: '',
        scoreCount: '',
        scoreNumber: '',
        desc1: '',
        desc2: '',
        desc3: '',
        desc4: '',
      },
      questionOptions: ['A', 'B', 'C', 'D'],
      chooseListAnswer: '',
      select: '单选题',
      value: '4',
      radio1: '',
      region: '单选题',
      textContent: '',
      labelName: '',
      textId:'',
      xcxList:[],
    };
  },
  created() {
    this.lookrule();
    console.log(this.$route.params,"这些数据");
  },
  methods: {
    //选择题
    selector() {
      console.log(this.chooseListAnswer, '1111');
    },
    //查看等级
    lookrule() {
      console.log(111);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/book?miniid='+this.$route.params.miniid+'&groupId='+this.$route.params.groupId+'&pageSize=&page=',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res, '查看等级');
          if (res.data.code === 0) {
           this.xcxList = res.data.data;
          }
        })
        .catch(() => {
          console.log(222);
        });
    },
    //提交短文及题目
    submit() {
      if(this.form.title ===""||this.form.content===""){
        return this.$message.error("题目不能为空！")
      }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/text',
        method: 'POST',
        data: {
          title: this.form.title,
          content: this.form.content,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, '提交了吗');
          if (result.data.code === 0) {
            // this.submitText();
            this.textId = result.data.data.textId;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('提交失败：' + err);
        });
    },
    //提交习题及选项
    submitText() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/question',
        method: 'POST',
        data: {
          title: this.form.title1,
          questionNum: this.textContent,
          answerItem: this.chooseListAnswer,
          textId: this.textId,
          questionOptions: [
            {
              item: 'A',
              option: this.form.desc1,
            },
            {
              item: 'B',
              option: this.form.desc2,
            },
            {
              item: 'C',
              option: this.form.desc3,
            },
            {
              item: 'D',
              option: this.form.desc4,
            },
          ],
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, '提交了问题及答案');
          if (result.data.code === 0) {
            this.onSubmit();
          }
        })
        .catch((err) => {
          console.log(err, '习题错误');
          // return this.$message.error('提交失败：' + err);
        });
    },
    //总提交
    onSubmit() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exam/readGrade/text/submit?textId='+this.textId+'&score=' + this.form.scoreNumber+'&levelId='+this.labelName,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log('okok成功了');
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.$router.push({ name: 'testmangement' });
          return this.$message.success(result.data.message);
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('提交失败：' + err);
        });
    },
  },
};
</script>

<style>
.mains {
  box-sizing: border-box;
}
.el-card_body {
  position: relative;
}
.tishi {
  position: absolute;
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 3.4375rem /* 55/16 */;
}
.form_1 {
  margin-top: 70px;
  margin-left: 273px;
}
.xiaoqu_1 {
  font-weight: 700;
}
.shurukuang {
  width: 560px;
}
.myQuillEditor {
  width: 46.875rem /* 750/16 */;
  /* height: 9.375rem 150/16; 200/16 */
}
.xtfl {
  width: 46.875rem /* 750/16 */;
}
.xtfl1 {
  width: 46.875rem /* 750/16 */;
  height: 12.5rem /* 200/16 */;
  border: 1px solid #cccccc;
}
.xtfl1 h3 {
  margin-left: 1.875rem /* 30/16 */;
  margin-top: 10px;
}
.example {
  margin-left: 1.875rem /* 30/16 */;
  margin-top: -20px;
}
.example span {
  display: inline-block;
  margin-right: 10px;
}
.example_img {
  margin-left: 1.875rem /* 30/16 */;
  width: 6.25rem /* 100/16 */;
  height: 6.25rem /* 100/16 */;
}
.options {
  display: flex;
  width: 46.875rem /* 750/16 */;
  height: 12.5rem /* 200/16 */;
  border: 1px solid #cccccc;
  margin-bottom: 20px;
}
.options_left {
  width: 130px;
  height: 100%;
  background-color: #cccccc;
  color: white;
  text-align: center;
}
.options_left p {
  font-size: 16px;
  margin-top: 70px;
}
.options_left_radio {
  color: #fff;
}
.addLable {
  width: 12.5rem /* 200/16 */;
  height: 2.25rem /* 36/16 */;
}
.btn_addlable {
  width: 6rem /* 96/16 */;
  height: 2.125rem /* 34/16 */;
  margin-left: 1.5625rem /* 25/16 */;
}
.el-textarea__inner {
  resize: none;
}
.score {
  display: flex;
}
.score > :nth-child(2) {
  margin: 0 110px 0 140px;
}
.grade {
  width: 6.25rem /* 100/16 */;
}
</style>
